import { useState, useEffect } from "react"
import { supabase } from "../lib/supabase"

export const ResetPassword = () => {
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState("")
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY") {
        setReady(true)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

const handleReset = async () => {
  if (!password.trim()) return
  setLoading(true)
  
  const { error } = await supabase.auth.updateUser({ password })
  
  if (error) {
    console.log("Reset error:", error.message)
    setError("Something went wrong. Try again.")
  } else {
    await supabase.auth.signOut()
    setDone(true)
  }
  setLoading(false)
}

  return (
    <div className="app">
      <div className="header">
        <h1>DECISION ZERO</h1>
      </div>
      <div className="step-container" style={{ flex: "none" }}>
        <div className="step-label" style={{ textAlign: "center", marginBottom: "24px" }}>
          BLINDSPOT
        </div>
        {done ? (
          <div style={{ textAlign: "center" }}>
  <div style={{ color: "var(--green)", fontSize: "15px", marginBottom: "16px" }}>
    Password updated.
  </div>
  <button
    onClick={() => window.location.href = "/"}
    className="btn-primary"
  >
    Log in
  </button>
</div>
        ) : !ready ? (
          <div style={{ textAlign: "center", color: "var(--text-muted)", fontSize: "13px" }}>
            Verifying...
          </div>
        ) : (
          <div>
            <div className="question-text" style={{ marginBottom: "20px", textAlign: "center" }}>
              Set a new password
            </div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="New password"
              style={{
                width: "100%",
                boxSizing: "border-box",
                background: "rgba(0,0,0,0.2)",
                border: "1px solid rgba(255,255,255,0.06)",
                borderRadius: "12px",
                padding: "14px 16px",
                color: "#e5e7eb",
                fontFamily: "inherit",
                fontSize: "16px",
                outline: "none",
                marginBottom: "12px",
              }}
            />
            {error && (
              <div style={{ color: "var(--red)", fontSize: "13px", marginBottom: "12px" }}>
                {error}
              </div>
            )}
            <button onClick={handleReset} disabled={loading} className="btn-primary" style={{ opacity: loading ? 0.4 : 1 }}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}